(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window._pcardJS) return;
  window._pcardJS = true;

  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function money(cents) { return fmt.format(cents / 100); }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-vpill]');
    if (!pill) return;

    var card = pill.closest('[data-product-card]');
    if (!card) return;

    var storVal = pill.dataset.storVal;
    var storPos = parseInt(card.dataset.storPos, 10);
    var optKey  = 'o' + storPos;
    var variants;

    try { variants = JSON.parse(card.dataset.variants || '[]'); }
    catch (err) { return; }

    /* Update pill active state */
    card.querySelectorAll('[data-vpill]').forEach(function (p) {
      var sel = p.dataset.storVal === storVal;
      p.classList.toggle('is-selected', sel);
      p.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });

    /* Find best match: available first, then any */
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i][optKey] === storVal && variants[i].a) { match = variants[i]; break; }
    }
    if (!match) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i][optKey] === storVal) { match = variants[i]; break; }
      }
    }
    if (!match) return;

    var priceEl   = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare]');
    var idInput   = card.querySelector('[data-card-variant-id]');
    var submitBtn = card.querySelector('[data-card-submit]');

    if (priceEl) priceEl.textContent = money(match.p);
    if (compareEl) {
      if (match.c && match.c > match.p) {
        compareEl.textContent = money(match.c);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (idInput)   idInput.value = match.id;
    if (submitBtn) {
      submitBtn.disabled = !match.a;
      submitBtn.setAttribute('aria-disabled', match.a ? 'false' : 'true');
      var btnTextEl = submitBtn.querySelector('[data-card-btn-text]');
      if (btnTextEl) btnTextEl.textContent = match.a ? btnTextEl.dataset.labelAvailable : 'Nicht verfügbar';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    'use strict';

    function initHeader(header) {
      // Scroll shadow
      const onScroll = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      // Mobile menu
      const hamburger = header.querySelector('.site-header__hamburger');
      const mobileNav = header.querySelector('.site-header__mobile-nav');
      const iconEl = hamburger && hamburger.querySelector('.material-symbols-outlined');

      if (!hamburger || !mobileNav || !iconEl) return;

      hamburger.addEventListener('click', () => {
        const isOpen = hamburger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          mobileNav.setAttribute('hidden', '');
          hamburger.setAttribute('aria-expanded', 'false');
          iconEl.textContent = 'menu';
        } else {
          mobileNav.removeAttribute('hidden');
          hamburger.setAttribute('aria-expanded', 'true');
          iconEl.textContent = 'close';
        }
      });

      // Close mobile nav on resize to desktop
      const mediaQuery = window.matchMedia('(min-width: 768px)');
      mediaQuery.addEventListener('change', (e) => {
        if (e.matches && hamburger.getAttribute('aria-expanded') === 'true') {
          mobileNav.setAttribute('hidden', '');
          hamburger.setAttribute('aria-expanded', 'false');
          iconEl.textContent = 'menu';
        }
      });
    }

    document.querySelectorAll('.site-header').forEach(initHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function setQty(key, delta) {
    var input = document.querySelector('[data-qty-input="' + key + '"]');
    if (!input) return;
    var next = Math.max(0, parseInt(input.value, 10) + delta);
    input.value = next;
    updateCart(key, next);
  }

  document.addEventListener('click', function (e) {
    var minus  = e.target.closest('[data-qty-minus]');
    var plus   = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-remove-item]');
    if (minus)  setQty(minus.dataset.qtyMinus,   -1);
    if (plus)   setQty(plus.dataset.qtyPlus,      +1);
    if (remove) updateCart(remove.dataset.removeItem, 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) updateCart(input.dataset.qtyInput, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ── Discount code ── */
  var discountInput = document.getElementById('mca-discount-input');
  var discountBtn   = document.getElementById('mca-discount-btn');
  var discountMsg   = document.getElementById('mca-discount-msg');

  function applyDiscount() {
    var code = discountInput ? discountInput.value.trim() : '';
    if (!code) return;
    discountBtn.disabled = true;
    discountBtn.textContent = '…';
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      redirect: 'manual',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (r) {
      if (discountMsg) {
        discountMsg.hidden = false;
        if (r.ok || r.type === 'opaqueredirect') {
          discountMsg.textContent = 'Gutscheincode "' + code + '" wird beim Checkout angewendet.';
          discountMsg.className = 'mca__discount-msg mca__discount-msg--ok';
          if (discountInput) discountInput.value = '';
        } else {
          discountMsg.textContent = 'Ungültiger oder abgelaufener Gutscheincode.';
          discountMsg.className = 'mca__discount-msg mca__discount-msg--err';
        }
      }
    })
    .catch(function () {
      /* Opaque CORS redirect = code likely valid; redirect to apply */
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    })
    .finally(function () {
      if (discountBtn) { discountBtn.disabled = false; discountBtn.textContent = 'Anwenden'; }
    });
  }

  if (discountBtn) discountBtn.addEventListener('click', applyDiscount);
  if (discountInput) discountInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') applyDiscount(); });

  function updateCart(key, quantity) {
    var li = document.querySelector('[data-cart-item="' + key + '"]');
    if (li) li.style.opacity = '0.45';

    var updates = {};
    updates[key] = quantity;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (quantity === 0) {
        if (li) li.remove();
        var remaining = document.querySelectorAll('.mca__item');
        if (remaining.length === 0) { window.location.reload(); return; }
      } else {
        if (li) li.style.opacity = '';
      }
      var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: cart.currency });
      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      var totalEl    = document.querySelector('[data-cart-total]');
      if (subtotalEl) subtotalEl.textContent = fmt.format(cart.total_price / 100);
      if (totalEl)    totalEl.textContent    = fmt.format(cart.total_price / 100);

      var badge = document.querySelector('.site-header__cart-badge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      }
    })
    .catch(function () { window.location.reload(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-filter-toggle]');
    var drawer = document.querySelector('[data-filter-drawer]');
    var backdrop = document.querySelector('[data-filter-backdrop]');
    var closeBtn = document.querySelector('[data-filter-close]');

    function openDrawer() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('[data-filter-checkbox]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        document.getElementById('coll-filter-form').submit();
      });
    });
  })();

  /* ── Variant pill switcher (shared guard with featured-collection) ── */
  (function () {
    if (window._pcardJS) return;
    window._pcardJS = true;

    var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    function money(cents) { return fmt.format(cents / 100); }

    document.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-vpill]');
      if (!pill) return;

      var card = pill.closest('[data-product-card]');
      if (!card) return;

      var storVal = pill.dataset.storVal;
      var storPos = parseInt(card.dataset.storPos, 10);
      var optKey  = 'o' + storPos;
      var variants;

      try { variants = JSON.parse(card.dataset.variants || '[]'); }
      catch (err) { return; }

      card.querySelectorAll('[data-vpill]').forEach(function (p) {
        var sel = p.dataset.storVal === storVal;
        p.classList.toggle('is-selected', sel);
        p.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i][optKey] === storVal && variants[i].a) { match = variants[i]; break; }
      }
      if (!match) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i][optKey] === storVal) { match = variants[i]; break; }
        }
      }
      if (!match) return;

      var priceEl   = card.querySelector('[data-card-price]');
      var compareEl = card.querySelector('[data-card-compare]');
      var idInput   = card.querySelector('[data-card-variant-id]');
      var submitBtn = card.querySelector('[data-card-submit]');

      if (priceEl) priceEl.textContent = money(match.p);
      if (compareEl) {
        if (match.c && match.c > match.p) {
          compareEl.textContent = money(match.c);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (idInput)   idInput.value = match.id;
      if (submitBtn) {
        submitBtn.disabled = !match.a;
        submitBtn.setAttribute('aria-disabled', match.a ? 'false' : 'true');
        var btnTextEl = submitBtn.querySelector('[data-card-btn-text]');
        if (btnTextEl) btnTextEl.textContent = match.a ? btnTextEl.dataset.labelAvailable : 'Nicht verfügbar';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-legal-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Table of contents (optional, only when sidebar is present) ── */
  var toc = document.getElementById('lp-toc');
  if (!toc) return;

  var nav  = toc.querySelector('.lp__toc-nav');
  var prose = document.querySelector('.lp__prose');
  if (!nav || !prose) return;

  var headings = prose.querySelectorAll('h2, h3');
  if (!headings.length) { toc.hidden = true; return; }

  headings.forEach(function (h, i) {
    if (!h.id) h.id = 'lp-h-' + i;
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.className = 'lp__toc-link' + (h.tagName === 'H3' ? ' lp__toc-link--sub' : '');
    a.textContent = h.textContent;
    nav.appendChild(a);
  });

  /* Highlight active heading on scroll */
  var links = nav.querySelectorAll('.lp__toc-link');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        links.forEach(function (l) { l.classList.remove('is-active'); });
        var active = nav.querySelector('a[href="#' + e.target.id + '"]');
        if (active) active.classList.add('is-active');
      }
    });
  }, { rootMargin: '-20% 0px -70% 0px' });

  headings.forEach(function (h) { observer.observe(h); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {

  /* ── Gallery ── */
  var galleryMain = document.getElementById('prod-gallery-main');
  var thumbBtns   = document.querySelectorAll('.mp__thumb');
  var slides      = document.querySelectorAll('.mp__slide');

  function scrollToSlide(idx) {
    var slide = slides[idx];
    if (!slide || !galleryMain) return;
    galleryMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    setActiveThumb(idx);
  }

  function setActiveThumb(idx) {
    thumbBtns.forEach(function (t, i) {
      var active = i === parseInt(idx, 10);
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      scrollToSlide(parseInt(btn.dataset.thumbIndex, 10));
    });
  });

  if (galleryMain && slides.length > 1) {
    var slideObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          setActiveThumb(parseInt(entry.target.dataset.index, 10));
        }
      });
    }, { root: galleryMain, threshold: 0.6 });
    slides.forEach(function (s) { slideObserver.observe(s); });
  }

  function scrollToMediaId(mediaId) {
    var slide = document.querySelector('.mp__slide[data-media-id="' + mediaId + '"]');
    if (slide) scrollToSlide(parseInt(slide.dataset.index, 10));
  }

  function scrollToColorImage(colorValue) {
    var lc = colorValue.toLowerCase();
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && img.alt && img.alt.toLowerCase().indexOf(lc) !== -1) {
        scrollToSlide(parseInt(slides[i].dataset.index, 10));
        return;
      }
    }
  }

  /* ── Variants ── */
  var productJson = document.getElementById('ProductJson');
  if (!productJson) return;

  var product   = JSON.parse(productJson.textContent);
  var variants  = product.variants;
  var options   = product.options;
  var numOpts   = options.length;

  /* Server renders selected_or_first_available_variant into the form input – start from the same variant */
  var formVariantInput = document.querySelector('[data-variant-id-input]');
  var initVariantId = parseInt(
    (new URLSearchParams(window.location.search)).get('variant') ||
    (formVariantInput && formVariantInput.value) ||
    variants[0].id, 10
  );
  var initVariant = variants.find(function (v) { return v.id === initVariantId; }) || variants[0];

  var selections = Array.from({ length: numOpts }, function (_, i) {
    return initVariant['option' + (i + 1)] || null;
  });

  var moneyFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function fmt(cents) { return moneyFmt.format(cents / 100); }

  var priceEl     = document.querySelector('[data-product-price]');
  var compareEl   = document.querySelector('[data-product-compare]');
  var badgeEl     = document.querySelector('[data-product-badge]');
  var badgeTextEl = document.querySelector('[data-product-badge-text]');
  var stockEl     = document.querySelector('[data-product-stock]');
  var idInput     = document.querySelector('[data-variant-id-input]');
  var cartBtn     = document.querySelector('[data-cart-btn]');
  var btnText     = cartBtn && cartBtn.querySelector('[data-btn-text]');
  var availLabel  = cartBtn && (cartBtn.dataset.availableLabel || 'In den Warenkorb');

  function findVariant(sels) {
    return variants.find(function (v) {
      return sels.every(function (val, i) {
        return val === null || v['option' + (i + 1)] === val;
      });
    });
  }

  function isAvailable(optIdx, val) {
    var test = selections.slice();
    test[optIdx] = val;
    return variants.some(function (v) {
      return test.every(function (s, i) { return s === null || v['option' + (i + 1)] === s; });
    });
  }

  function applyVariant(variant) {
    if (!variant) return;

    if (priceEl) priceEl.textContent = fmt(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var saved = variant.compare_at_price - variant.price;
      var pct   = Math.round(saved / variant.compare_at_price * 100);
      if (compareEl)   { compareEl.textContent = fmt(variant.compare_at_price); compareEl.hidden = false; }
      if (badgeEl)     { badgeEl.textContent = '-' + pct + '%'; badgeEl.hidden = false; }
      if (badgeTextEl) { badgeTextEl.textContent = '-' + pct + '%'; badgeTextEl.hidden = false; }
    } else {
      if (compareEl)   compareEl.hidden = true;
      if (badgeEl)     badgeEl.hidden = true;
      if (badgeTextEl) badgeTextEl.hidden = true;
    }

    if (stockEl) {
      stockEl.dataset.available = variant.available ? 'true' : 'false';
      var iconEl = stockEl.querySelector('.mp__stock-icon--in, .mp__stock-icon--out');
      var textEl = stockEl.querySelector('.mp__stock-text');
      if (variant.available) {
        if (iconEl) { iconEl.className = 'material-symbols-outlined mp__stock-icon mp__stock-icon--in'; iconEl.textContent = 'check_circle'; }
        if (textEl) { textEl.textContent = 'Sofort lieferbar (1–3 Werktage)'; textEl.classList.remove('mp__stock-text--out'); }
      } else {
        if (iconEl) { iconEl.className = 'material-symbols-outlined mp__stock-icon mp__stock-icon--out'; iconEl.textContent = 'cancel'; }
        if (textEl) { textEl.textContent = 'Derzeit nicht verfügbar'; textEl.classList.add('mp__stock-text--out'); }
      }
    }

    if (cartBtn) {
      cartBtn.disabled = !variant.available;
      cartBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      if (btnText) btnText.textContent = variant.available ? availLabel : 'Nicht verfügbar';
    }

    if (idInput) idInput.value = variant.id;

    var lowStockEl = document.querySelector('[data-low-stock]');
    if (lowStockEl) {
      var qty = variant.inventory_quantity;
      var managed = variant.inventory_management && variant.inventory_management !== 'none';
      if (variant.available && managed && qty > 0 && qty <= 5) {
        lowStockEl.hidden = false;
        var lsIcon = lowStockEl.querySelector('.mp__low-stock-icon');
        var lsText = lowStockEl.querySelector('.mp__low-stock-text');
        if (!lsIcon) {
          lsIcon = document.createElement('span');
          lsIcon.className = 'material-symbols-outlined mp__low-stock-icon';
          lsIcon.setAttribute('aria-hidden', 'true');
          lsIcon.style.fontVariationSettings = "'FILL' 1,'wght' 400,'GRAD' 0,'opsz' 20";
          lsIcon.textContent = 'error';
          lsText = document.createElement('span');
          lsText.className = 'mp__low-stock-text';
          lowStockEl.textContent = '';
          lowStockEl.appendChild(lsIcon);
          lowStockEl.appendChild(lsText);
        }
        lsText.textContent = 'Nur noch ' + qty + ' Stück verfügbar';
      } else {
        lowStockEl.hidden = true;
      }
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    if (variant.featured_media) scrollToMediaId(variant.featured_media.id);
  }

  function syncDisabled() {
    document.querySelectorAll('input[type="radio"][data-opt-index]').forEach(function (inp) {
      inp.disabled = !isAvailable(parseInt(inp.dataset.optIndex, 10), inp.dataset.optValue);
    });
  }

  function updateWarranty(value) {
    var warrantyEl = document.querySelector('[data-warranty-title]');
    if (!warrantyEl) return;
    var isNeu = value.toLowerCase().trim() === 'neu';
    warrantyEl.textContent = isNeu ? '24 Monate Garantie' : '12 Monate Garantie';
  }

  function handleSelect(optionIndex, value) {
    selections[optionIndex] = value;
    var wrap    = document.querySelector('[data-option-wrap="' + optionIndex + '"]');
    var display = wrap && wrap.querySelector('[data-option-value-display]');
    if (display) display.textContent = value;
    var variant = findVariant(selections);
    if (variant) applyVariant(variant);
    if (wrap && wrap.hasAttribute('data-is-color') && (!variant || !variant.featured_media)) {
      scrollToColorImage(value);
    }
    if (wrap && wrap.hasAttribute('data-is-condition')) {
      updateWarranty(value);
    }
    syncDisabled();
  }

  document.querySelectorAll('input[type="radio"][data-opt-index]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      handleSelect(parseInt(inp.dataset.optIndex, 10), inp.dataset.optValue);
    });
  });

  syncDisabled();

  /* ── Init gallery on page load: show the selected variant's image (or matching colour) ── */
  (function initGalleryForVariant() {
    if (!galleryMain) return;
    var targetSlide = null;
    if (initVariant && initVariant.featured_media) {
      targetSlide = document.querySelector('.mp__slide[data-media-id="' + initVariant.featured_media.id + '"]');
    }
    if (!targetSlide) {
      var colorWrap = document.querySelector('[data-is-color]');
      var checkedColor = colorWrap && colorWrap.querySelector('input[type="radio"]:checked');
      if (checkedColor) {
        var lc = checkedColor.dataset.optValue.toLowerCase();
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && img.alt && img.alt.toLowerCase().indexOf(lc) !== -1) { targetSlide = slides[i]; break; }
        }
      }
    }
    if (!targetSlide) return;
    galleryMain.scrollLeft = targetSlide.offsetLeft;
    setActiveThumb(parseInt(targetSlide.dataset.index, 10));
  })();

  /* ── Init warranty on page load ── */
  var condWrap = document.querySelector('[data-is-condition]');
  if (condWrap) {
    var checkedCond = condWrap.querySelector('input[type="radio"]:checked');
    if (checkedCond) updateWarranty(checkedCond.dataset.optValue);
  }

  /* ── Sticky bar ── */
  var stickyBar = document.getElementById('mp-sticky-bar');
  var stickyBtn = stickyBar && stickyBar.querySelector('[data-sticky-cart-btn]');
  var stickyPriceEl = stickyBar && stickyBar.querySelector('[data-sticky-price]');

  if (stickyBar && cartBtn) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    stickyObserver.observe(cartBtn);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var form = document.getElementById('product-form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  var origApplyVariant = applyVariant;
  applyVariant = function (variant) {
    origApplyVariant(variant);
    if (stickyPriceEl && variant) {
      stickyPriceEl.textContent = fmt(variant.price);
    }
    if (stickyBtn && variant) {
      stickyBtn.disabled = !variant.available;
    }
  };

  /* ── Lightbox ── */
  var lightbox         = document.getElementById('mp-lightbox');
  var lightboxImg      = document.getElementById('mp-lightbox-img');
  var lightboxClose    = document.getElementById('mp-lightbox-close');
  var lightboxBackdrop = document.getElementById('mp-lightbox-backdrop');

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    lightboxClose && lightboxClose.focus();
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.mp__slide-img').forEach(function (img) {
    img.addEventListener('click', function () {
      var hires = img.src.replace(/width=\d+/, 'width=1600');
      openLightbox(hires, img.alt);
    });
  });
  if (lightboxClose)    lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
  });

  /* ── Wishlist (localStorage) ── */
  var wishBtn   = document.getElementById('mp-wish-btn');
  var toastEl   = document.getElementById('mp-toast');
  var toastText = document.getElementById('mp-toast-text');
  var toastTimer;

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('hm_wishlist') || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('hm_wishlist', JSON.stringify(list)); } catch (e) {}
  }
  function showToast(msg) {
    if (!toastEl || !toastText) return;
    toastText.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2500);
  }
  function syncWishBtn(isSaved) {
    if (!wishBtn) return;
    wishBtn.classList.toggle('is-saved', isSaved);
    var label = wishBtn.querySelector('.mp__wish-label');
    if (label) label.textContent = isSaved ? 'Auf der Wunschliste' : 'Auf die Wunschliste';
    wishBtn.setAttribute('aria-label', isSaved ? 'Von der Wunschliste entfernen' : 'Auf die Wunschliste');
  }

  if (wishBtn) {
    var prodId    = parseInt(wishBtn.dataset.productId, 10);
    var prodTitle = wishBtn.dataset.productTitle || '';
    var list      = getWishlist();
    syncWishBtn(list.indexOf(prodId) !== -1);

    wishBtn.addEventListener('click', function () {
      var wl    = getWishlist();
      var idx   = wl.indexOf(prodId);
      var added = idx === -1;
      if (added) { wl.push(prodId); showToast('"' + prodTitle + '" zur Wunschliste hinzugefügt'); }
      else        { wl.splice(idx, 1); showToast('"' + prodTitle + '" von der Wunschliste entfernt'); }
      saveWishlist(wl);
      syncWishBtn(added);
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var placeholder = document.querySelector('[data-recommendations-url][data-product-id]');
    if (!placeholder) return;

    var productId = placeholder.dataset.productId;
    var sectionId = placeholder.dataset.sectionId;
    var intent    = placeholder.dataset.intent || 'related';
    var limit     = placeholder.dataset.limit || 4;
    var baseUrl   = placeholder.dataset.recommendationsUrl;

    var url = baseUrl + '?product_id=' + productId + '&section_id=' + sectionId + '&intent=' + intent + '&limit=' + limit;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var section = tmp.querySelector('[data-product-recommendations]');
        if (section) {
          placeholder.parentNode.replaceChild(section, placeholder);
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.innerWidth >= 768) return;
  var inner = document.querySelector('.trust-bar__inner');
  if (!inner) return;
  inner.insertAdjacentHTML('beforeend', inner.innerHTML);
  inner.classList.add('trust-bar__inner--marquee');
})();

  } catch(e) { console.error(e); }
})();
})();
